export const iconFontAwesomeTimeBellSlash = (
	<i className="fa-solid fa-bell-slash"></i>
);
